import { attr, belongsTo } from 'spraypaint';
import ApplicationRecord from './ApplicationRecord';

const Addon = ApplicationRecord.extend({
  static: {
    jsonapiType: 'addons',
  },
  attrs: {
    name: attr(),
    priceWith: attr(),
    priceWithout: attr(),
    isElementary: attr(),
    // ⚠️ ONE COLUMN, TWO NAMES. `onGiftsPage` says what it decides -- does this
    // add-on appear on the Announcements & Gifts grid. `isHoliday` is the
    // database column's original name, kept because carts and sheets built
    // before the rename still carry it (see DisplayableSheet, CartItem
    // DetailedView) and a customer's already-loaded page still sends it.
    isHoliday: attr(),
    onGiftsPage: attr(),
    isSenior: attr(),
    popup: attr(),
    cssName: attr(),
    // WHICH PRODUCT SCREEN this row sells on -- the `?product=` in the gifts
    // page's URL, and the key ItemAdder groups a screen's quantity steppers by.
    //
    // ⚠️ NOT a synonym for `cssName`, which is the RENDERER. Rows sharing a
    // product key are one product with several quantities (the five Wallets
    // rows); rows sharing only a cssName are different products drawn the same
    // way (the neutral and school-theme weekly dry-erase magnets). Resolved
    // SERVER-side and never null -- a blank column falls back to css_name, so
    // every legacy row groups exactly as it always has.
    productKey: attr(),
    // WHICH PHOTOS THIS DESIGN CAN HOLD, derived SERVER-side from the photo
    // placement (Addon::POSE_RULES_BY_CSS_NAME) so every product drawn by a
    // renderer inherits one answer. Both are TRI-STATE -- `undefined`/null
    // means "as before" and is NOT the same as `false`; `poseEligibility.js`
    // owns reading them. A Spraypaint attr that is not declared arrives
    // undefined no matter what the API serves, which would read as "as before"
    // and silently disable the whole feature.
    allowsLandscapePoses: attr(),
    allowsJpgPoses: attr(),
    // Which section of the Announcements & Gifts page this product sits under.
    // Resolved SERVER-side (Addon#gift_category) so the grouping has one
    // implementation: a product re-filed on /admin/addons moves without a
    // deploy, and the front end sorts sections on the served position rather
    // than trusting a hash's key order to survive serialization.
    giftCategory: attr(),
    giftCategoryLabel: attr(),
    giftCategoryPosition: attr(),
    createdAt: attr(),
    updatedAt: attr(),
    imageCount: attr(),
    component: belongsTo(),
    description: attr(),
    tagline: attr(),
    // The one-line spec under the name on the shelf ("Set of 25"). Its own
    // field because `description` and `tagline` are entered inconsistently --
    // see Api::AddonResource. Blank renders no line at all.
    detailLine: attr(),
    quantity: attr(),
    imageUrl: attr(),
    backImageUrl: attr(),
    blankImageUrl: attr(),
    horizImageUrl: attr(),
    backgroundSelection: attr(),
  },
});

export default Addon;
